import * as React from "react";

function SvgIconCameraOffset(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M0 0h4.25c.782 0 1.417.634 1.417 1.417v1.416c0 .783-.635 1.417-1.417 1.417H0V0z"
        fill="#414042"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.667h12.484c.93 0 1.683.74 1.683 1.652v16.528c0 .913-.753 1.653-1.683 1.653H0v-1.682c.234.02.47.03.708.03 4.646 0 8.412-3.7 8.412-8.265C9.12 11.02 5.354 7.32.708 7.32c-.238 0-.474.01-.708.03V5.666zm9.96 1.652a.834.834 0 00-.84.827v1.653c0 .456.376.826.84.826h1.683c.465 0 .841-.37.841-.826V8.146a.834.834 0 00-.84-.827H9.96z"
        fill="#414042"
      />
      <path
        d="M.708 22.194c-.239 0-.475-.012-.708-.036V9.008c.233-.024.47-.036.708-.036 3.717 0 6.73 2.96 6.73 6.611 0 3.652-3.013 6.611-6.73 6.611zM19.833 7.32c0-.913.754-1.653 1.683-1.653H34v1.681a8.675 8.675 0 00-.708-.029c-4.646 0-8.412 3.7-8.412 8.264 0 4.564 3.766 8.264 8.412 8.264.238 0 .474-.01.708-.029V25.5H21.516c-.93 0-1.683-.74-1.683-1.653V7.32z"
        fill="#414042"
      />
      <path
        d="M33.292 8.972c.239 0 .475.012.708.036v13.15c-.233.024-.47.036-.708.036-3.717 0-6.73-2.96-6.73-6.61 0-3.652 3.013-6.612 6.73-6.612zM0 28.333h2.833v1.417h4.25v2.833h-4.25V34H0v-5.667zM9.917 29.75h5.666v2.833H9.917V29.75zM24.083 29.75h-5.666v2.833h5.666V29.75zM26.917 29.75h4.25v-1.417H34V34h-2.833v-1.417h-4.25V29.75zM29.75 0H34v4.25h-4.25a1.417 1.417 0 01-1.417-1.417V1.417C28.333.634 28.968 0 29.75 0z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgIconCameraOffset;
